import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-white/95'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="text-xl md:text-2xl font-bold text-[#2C3E50] hover:text-[#FF9B7A] transition-colors cursor-pointer" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            おかやま保険株式会社
          </Link>
          
          {/* デスクトップメニュー */}
          <nav className="hidden md:flex items-center gap-6 lg:gap-8">
            <Link 
              to="/services" 
              className={`text-[#2C3E50] hover:text-[#FF9B7A] transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/services' ? 'font-bold text-[#FF9B7A]' : ''
              }`}
            >
              事業内容
            </Link>
            <Link 
              to="/about" 
              className={`text-[#2C3E50] hover:text-[#FF9B7A] transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/about' ? 'font-bold text-[#FF9B7A]' : ''
              }`}
            >
              会社概要
            </Link>
            <Link 
              to="/careers" 
              className={`text-[#2C3E50] hover:text-[#FF9B7A] transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/careers' ? 'font-bold text-[#FF9B7A]' : ''
              }`}
            >
              求人情報
            </Link>
            <Link 
              to="/blog" 
              className={`text-[#2C3E50] hover:text-[#FF9B7A] transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/blog' ? 'font-bold text-[#FF9B7A]' : ''
              }`}
            >
              ブログ&新着情報
            </Link>
            <Link 
              to="/contact" 
              className="bg-[#FF9B7A] text-white px-6 py-2.5 rounded-full hover:bg-[#FF8A65] transition-colors whitespace-nowrap cursor-pointer font-medium"
            >
              お問い合わせ
            </Link>
          </nav>

          {/* ハンバーガーメニューボタン */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex flex-col items-center justify-center gap-1.5 cursor-pointer"
            aria-label="メニュー"
          >
            <span
              className={`w-6 h-0.5 bg-[#2C3E50] transition-all duration-300 ${
                isMobileMenuOpen ? 'rotate-45 translate-y-2' : ''
              }`}
            ></span>
            <span
              className={`w-6 h-0.5 bg-[#2C3E50] transition-all duration-300 ${
                isMobileMenuOpen ? 'opacity-0' : ''
              }`}
            ></span>
            <span
              className={`w-6 h-0.5 bg-[#2C3E50] transition-all duration-300 ${
                isMobileMenuOpen ? '-rotate-45 -translate-y-2' : ''
              }`}
            ></span>
          </button>
        </div>
      </header>

      {/* モバイルメニュー */}
      <div
        className={`fixed inset-0 bg-black/50 z-40 transition-opacity duration-300 md:hidden ${
          isMobileMenuOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
        onClick={() => setIsMobileMenuOpen(false)}
      ></div>

      <nav
        className={`fixed top-0 right-0 bottom-0 w-80 bg-white z-50 shadow-2xl transform transition-transform duration-300 md:hidden ${
          isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex flex-col h-full">
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
            <span className="text-lg font-bold text-[#2C3E50]" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              メニュー
            </span>
            <button
              onClick={() => setIsMobileMenuOpen(false)}
              className="w-10 h-10 flex items-center justify-center cursor-pointer"
              aria-label="閉じる"
            >
              <i className="ri-close-line text-2xl text-[#2C3E50]"></i>
            </button>
          </div>

          <div className="flex-1 overflow-y-auto py-6">
            <Link
              to="/"
              className={`flex items-center px-6 py-4 text-[#2C3E50] hover:bg-[#FAF8F3] transition-colors cursor-pointer ${
                location.pathname === '/' ? 'bg-[#FAF8F3] font-bold text-[#FF9B7A]' : ''
              }`}
            >
              <i className="ri-home-line text-xl mr-4 w-6 h-6 flex items-center justify-center"></i>
              <span>ホーム</span>
            </Link>
            <Link
              to="/services"
              className={`flex items-center px-6 py-4 text-[#2C3E50] hover:bg-[#FAF8F3] transition-colors cursor-pointer ${
                location.pathname === '/services' ? 'bg-[#FAF8F3] font-bold text-[#FF9B7A]' : ''
              }`}
            >
              <i className="ri-shield-check-line text-xl mr-4 w-6 h-6 flex items-center justify-center"></i>
              <span>事業内容</span>
            </Link>
            <Link
              to="/about"
              className={`flex items-center px-6 py-4 text-[#2C3E50] hover:bg-[#FAF8F3] transition-colors cursor-pointer ${
                location.pathname === '/about' ? 'bg-[#FAF8F3] font-bold text-[#FF9B7A]' : ''
              }`}
            >
              <i className="ri-building-line text-xl mr-4 w-6 h-6 flex items-center justify-center"></i>
              <span>会社概要</span>
            </Link>
            <Link
              to="/careers"
              className={`flex items-center px-6 py-4 text-[#2C3E50] hover:bg-[#FAF8F3] transition-colors cursor-pointer ${
                location.pathname === '/careers' ? 'bg-[#FAF8F3] font-bold text-[#FF9B7A]' : ''
              }`}
            >
              <i className="ri-briefcase-line text-xl mr-4 w-6 h-6 flex items-center justify-center"></i>
              <span>求人情報</span>
            </Link>
            <Link
              to="/blog"
              className={`flex items-center px-6 py-4 text-[#2C3E50] hover:bg-[#FAF8F3] transition-colors cursor-pointer ${
                location.pathname === '/blog' ? 'bg-[#FAF8F3] font-bold text-[#FF9B7A]' : ''
              }`}
            >
              <i className="ri-article-line text-xl mr-4 w-6 h-6 flex items-center justify-center"></i>
              <span>ブログ&新着情報</span>
            </Link>
            <Link
              to="/contact"
              className={`flex items-center px-6 py-4 text-[#2C3E50] hover:bg-[#FAF8F3] transition-colors cursor-pointer ${
                location.pathname === '/contact' ? 'bg-[#FAF8F3] font-bold text-[#FF9B7A]' : ''
              }`}
            >
              <i className="ri-mail-line text-xl mr-4 w-6 h-6 flex items-center justify-center"></i>
              <span>お問い合わせ</span>
            </Link>
          </div>

          <div className="border-t border-gray-200 px-6 py-6">
            <div className="space-y-3">
              <div className="flex items-center text-sm text-gray-600">
                <i className="ri-phone-line text-lg mr-3 w-5 h-5 flex items-center justify-center"></i>
                <span>086-012-3456</span>
              </div>
              <div className="flex items-center text-sm text-gray-600">
                <i className="ri-time-line text-lg mr-3 w-5 h-5 flex items-center justify-center"></i>
                <span>9:00 〜 18:00</span>
              </div>
              <div className="flex items-center text-sm text-gray-600">
                <i className="ri-calendar-line text-lg mr-3 w-5 h-5 flex items-center justify-center"></i>
                <span>定休日：日曜・祝日</span>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}
